import JSZip from 'jszip';
import clientLogger from '../../lib/logger';

const getFileArray = (zip) => Object.keys(zip.files).map((fullPath) => zip.files[fullPath]);

const getBaseZipFile = async ({ appIntegrationType, product, frontend, backend }) => {
  const zip = new JSZip();
  try {
    const url = `/studio/api/v1/integration/code/download?product=${product}&frontend=${frontend}&backend=${backend}&appIntegrationType=${appIntegrationType}`;
    const response = await fetch(url);
    const result = await response.json();

    await zip.loadAsync(result.file, { base64: true });
  } catch {
    clientLogger.error('CLIENT:ERROR', { error: 'Error fetching zip file' });
    return null;
  }
  return zip;
};

export { getBaseZipFile, getFileArray };
